import NextApp from "next/app";

const getInitialProps = context => NextApp.getInitialProps(context);

const withGetInitialProps = App => {
	// eslint-disable-next-line no-param-reassign
	App.getInitialProps = App.getInitialProps || getInitialProps;
	return App;
};

export default withGetInitialProps;
